<!-- eslint-disable -->
<template>
  <div class="create-meeting">
    <div class="filter-bar">
      <a-radio-group v-model="filterNow">
        <a-radio-button :value="'seed'"> Seed({{ seedNum }}) </a-radio-button>
        <a-radio-button :value="'venture'"> Venture({{ ventureNum }}) </a-radio-button>
        <a-radio-button :value="'growth'"> Growth({{ growthNum }}) </a-radio-button>
      </a-radio-group>
      <a-button type="primary" @click="confirm">完成排会</a-button>
    </div>
    <div class="create-meeting">
      <meeting-table
        v-show="filterNow == 'seed'"
        :meetingProjectList="meetingInfo.seed.projects"
        :meetingType="1"
        :meetingTitle="1"
        ref="seed"
        @save="refresh('seed')"
      >
      </meeting-table>
      <!-- <meeting-table
        v-show="filterNow == 'seed'"
        :meetingProjectList="meetingInfo.seedOffline.projects"
        @save="refresh('seedOffline')"
        ref="seedOffline"
        :meetingType="2"
        :meetingTitle="1"
      >
      </meeting-table> -->
      <meeting-table
        v-show="filterNow == 'venture'"
        :meetingProjectList="meetingInfo.venture.projects"
        @save="refresh('venture')"
        ref="venture"
        :meetingType="1"
        :meetingTitle="2"
      >
      </meeting-table>
      <!-- <meeting-table
        v-show="filterNow == 'venture'"
        :meetingProjectList="meetingInfo.ventureOffline.projects"
        @save="refresh('ventureOffline')"
        ref="ventureOffline"
        :meetingType="2"
        :meetingTitle="2"
      >
      </meeting-table> -->
      <meeting-table
        v-show="filterNow == 'growth'"
        :meetingProjectList="meetingInfo.growth.projects"
        @save="refresh('growth')"
        ref="growth"
        :meetingType="1"
        :meetingTitle="3"
      >
      </meeting-table>
      <!-- <meeting-table
        v-show="filterNow == 'growth'"
        :meetingProjectList="meetingInfo.growthOffline.projects"
        @save="refresh('growthOffline')"
        ref="growthOffline"
        :meetingType="2"
        :meetingTitle="3"
      >
      </meeting-table> -->
    </div>
    <a-modal :visible="modal.visible" @ok="modalOk" @cancel="modalCancel" type="info">
      <div class="modal-title">
        <a-icon class="modal-title-icon" type="exclamation-circle" theme="filled" />
        是否确认提交
      </div>
      <div class="modal-content">
        <div class="item">提交后，所选项目将会排会成功，并且会执行以下操作</div>
        <div class="item" :class="modal.addCalendar ? '' : 'item-disable'">
          1. 将会按照所选时间对所属项目的参会人预定飞书日程 <a-switch size="small" v-model="modal.addCalendar" />
        </div>

        <div class="item" :class="modal.sendFeishuMsg ? '' : 'item-disable'">
          2. 将向本次会议关联飞书群发送项目的上会信息 <a-switch size="small" v-model="modal.sendFeishuMsg" />
        </div>
        <!--        <div class="item-tip" v-if="modal.sendFeishuMsg">{{ modal.message }}</div>-->
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment';
import meetingTable from '@/components/meeting/meetingTable';
// import fullStaff from '@/components/meeting/fullStaff';
import { saveMeeting, getMeetingInfo, meetingStaticInfo } from '@/api/meeting';
import { meetingTemplateCategory, templateNameMap } from '@/utils/project';
export default {
  moment,
  name: 'createMeeting',
  components: {
    meetingTable
    // regularTpl,
    // fullStaff
  },
  watch: {},
  computed: {
    seedNum() {
      let onlineNum = this.meetingInfo.seed.projects ? this.meetingInfo.seed.projects.length : 0;
      // let offlineNum = this.meetingInfo.seedOffline.projects ? this.meetingInfo.seedOffline.projects.length : 0;
      return onlineNum;
    },
    ventureNum() {
      let onlineNum = this.meetingInfo.venture.projects ? this.meetingInfo.venture.projects.length : 0;
      // let offlineNum = this.meetingInfo.ventureOffline.projects ? this.meetingInfo.ventureOffline.projects.length : 0;
      return onlineNum;
    },
    growthNum() {
      let onlineNum = this.meetingInfo.growth.projects ? this.meetingInfo.growth.projects.length : 0;
      // let offlineNum = this.meetingInfo.growthOffline.projects ? this.meetingInfo.growthOffline.projects.length : 0;
      return onlineNum;
    }
  },
  data() {
    return {
      isEdit: false,
      filterNow: 'seed',
      meetingInfo: {
        common: {},

        seed: {},
        // seedOffline: {},

        venture: {},
        // ventureOffline: {},

        growth: {}
        // growthOffline: {}
      },
      modal: {
        visible: false,
        data: {},
        dataKeys: [{ key: 'seed' }, { key: 'venture' }, { key: 'growth' }],
        message: 'ss',
        sendFeishuMsg: true,
        addCalendar: true
      }
    };
  },
  created() {
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    // 在导航离开渲染该组件的对应路由时调用
    const answer = window.confirm('当前页面内容尚未保存，跳转到其他页面将会丢失当前编辑的内容，是否确认跳转？');
    if (answer === false) {
      // 刷新tab,如果返回是false重置tab为未排会
      this.$emit('updateTab');
    }
    next(answer);
  },
  methods: {
    async init() {
      try {
        let res = await getMeetingInfo({
          meetingId: this.meetingId
        });
        this.meetingInfo = res.data;
        this.meetingName = res.data.common ? res.data.common.meetingName : '';
        this.$emit('updateNum');
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async refresh() {
      try {
        // 新建排会
        let res = await getMeetingInfo({
          meetingId: this.meetingId
        });
        this.meetingInfo = res.data;
        this.$emit('updateNum');
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async modalOk() {
      this.modal.visible = false;
      let res = await saveMeeting({ ...this.modal.data, sendFeishuMsg: this.modal.sendFeishuMsg, addCalendar: this.modal.addCalendar });

      if (res.code === 200) {
        this.$message.success(`排会成功`);
        this.refresh();
      } else {
        this.$message.error(res.msg);
      }
    },
    modalCancel() {
      this.modal.visible = false;
    },
    confirm() {
      let data = {};
      let length = 0;
      this.modal.dataKeys.forEach(item => {
        data[item.key] = this.$refs[item.key].submit();
        console.log(this.$refs[item.key].submit());
        length += data[item.key].projects.length;
      });
      if (length === 0) {
        this.$message.error('无待排会议');
        return;
      }
      if (!this.isValid(data.seed.projects)) {
        this.filterNow = 'seed';
        return;
      }
      if (!this.isValid(data.venture.projects)) {
        this.filterNow = 'venture';
        return;
      }
      if (!this.isValid(data.growth.projects)) {
        this.filterNow = 'growth';
        return;
      }

      this.modal.visible = true;
      this.modal.data = data;
      this.modal.sendFeishuMsg = true;
      this.modal.addCalendar = true;
      let message = '本周上会项目 \n';
      if (data.seed.projects.length > 0) {
        message += 'Seed \n';
        let projects = [...data.seed.projects];
        message += projects
          .map(i => {
            return `${moment(i.startTime * 1000).format('YYYY.MM.DD HH:mm')}  ${i.sectorName}  ${i.followType === 0 ? 'Follow On' : 'New'}  ${
              i.secret ? '保密' : '公开'
            }  ${i.description}`;
          })
          .join('\n');
        message += '\n';
      }
      if (data.venture.projects.length) {
        message += 'Venture \n';
        let projects = [...data.venture.projects];
        message += projects
          .map(i => {
            return `${moment(i.startTime * 1000).format('YYYY.MM.DD HH:mm')}  ${i.sectorName}  ${i.followType === 0 ? 'Follow On' : 'New'}  ${
              i.secret ? '保密' : '公开'
            }  ${i.description}`;
          })
          .join('\n');
        message += '\n';
      }
      if (data.growth.projects.length) {
        message += 'Growth \n';
        let projects = [...data.growth.projects];
        message += projects
          .map(i => {
            return `${moment(i.startTime * 1000).format('YYYY.MM.DD HH:mm')}  ${i.sectorName}  ${i.followType === 0 ? 'Follow On' : 'New'}  ${
              i.secret ? '保密' : '公开'
            }  ${i.description}`;
          })
          .join('\n');
        message += '\n';
      }

      this.modal.message = message;
      this.modal.data = data;
    },
    isValid(list) {
      let res = false;
      // console.log(this.data);

      for (let i of list) {
        // console.log(i);
        if (i['active']) {
          if (!i['groupId']) {
            this.$message.error(i['name'] + '暂未选择/新建飞书群，请选择/新建飞书群后再次操作');
            return false;
          }
          let startTimeTmp = moment.unix(i['startTime']);
          let endTimeTmp = moment.unix(i['endTime']);
          let res = i['endTime'] === 0;
          if (res) {
            this.$message.error(i['name'] + '项目暂未选择上会时间，请选择上会时间后再次操作');
            return false;
          }
        }
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.create-meeting {
  background: white;
  min-height: calc(100vh - 116px);
  .filter-bar {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    /deep/.ant-radio-button-wrapper {
      padding: 4px 20px;
      height: 40px;
      span {
        font-weight: 700;
      }
    }
  }
}
.modal-title {
  .modal-title-icon {
    color: rgba(247, 157, 19, 1);
  }
}
.modal-content {
  padding: 5px 5px 5px 15px;
  color: #999;
  .item {
    padding: 5px 0;
    display: flex;
    justify-content: space-between;
  }
  .item-disable {
    color: rgba(0, 0, 0, 0.25);
  }
  .item-tip {
    border: 1px solid rgba(252, 224, 126, 1);
    background-color: rgba(254, 251, 224);
    border-radius: 5px;
    padding: 10px;
    white-space: pre-line;
  }
}
</style>
